import { Prices } from '../import-prices/import-prices';
import pricesJson from './prices.json';

// Get the user's country based on their browser language setting.
function getUserCountryCode(): string {
    // Get the language tag from the browser's language setting.
    let languageTag = navigator.language;

    // Extract the country code from the language tag.
    let parts = languageTag.split('-');

    // If there's a second part, return it as the country code.
    if (parts.length > 1) {
        return parts[1];
    }

    // If there's no country code, return the entire language tag.
    return languageTag;
}

function replacePriceText(): void {
    const userCountryCode = getUserCountryCode().toUpperCase();
    const prices = pricesJson as Prices;
    const price = prices[userCountryCode] || prices['DE'];

    const replacementPatterns: { [key: string]: string } = {
        '[currency_symbol]': price.currencySymbol,
        '[price_monthly]': price.priceMonthly,
        '[price_yearly]': price.priceYearly,
        '[price_yearly_per_month]': price.priceYearlyPerMonth,
        '[price_yearly_without_discount]': price.priceYearlyWithoutDiscount,
        '[price_rlbs]': price.priceRegularLightBarrierSystem,
    };

    const escapedPatterns = Object.keys(replacementPatterns).map(pattern => pattern.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&')); // Escape special characters
    const combinedPattern = new RegExp(escapedPatterns.join('|'), 'g');

    function replacer(match: string): string {
        return replacementPatterns[match] || match;
    }

    const allTextNodes = document.createNodeIterator(document.body, NodeFilter.SHOW_TEXT);

    let node: Node | null;
    while (node = allTextNodes.nextNode()) {
        if (node.textContent !== null) {
            node.textContent = node.textContent.replace(combinedPattern, replacer);
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    replacePriceText();
});
